var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid d-flex flex-column-reverse flex-sm-column-reverse flex-md-column-reverse flex-lg-row flex-xl-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"d-flex flex-column"},[_c('TrackList')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }